import Request from '@/plugins/request';

export function getBaseConfigs(params) {
  return Request.get('base-configs', { params })
}

export function createBaseConfig() {
  return Request.get(`base-configs/create`)
}

export function storeBaseConfig(data) {
  return Request.post('base-configs', data)
}

export function updateBaseConfig(id, data) {
  return Request.put(`base-configs/${id}`, data)
}

export function editBaseConfig(id) {
  return Request.get(`base-configs/${id}/edit`)
}

export function destroyBaseConfig(id) {
  return Request.delete(`base-configs/${id}`)
}
